export const DROPZONE_MAX_FILE_3MB = 3000000;
export const DROPZONE_MAX_FILE_3MB_TEXT = "3MB";
